import React from 'react';

const Theory_of_Mind = () => {
    return (
        <div>Theory_of_Mind Component</div>
    );
}

export default Theory_of_Mind;
